import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Segment, Dimmer, Image, Loader } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { confirmAlert } from 'react-confirm-alert';
import Popup from 'reactjs-popup';

// Data
import { SubtitleContext } from '../../contexts/SubtitleContext';

// Utils
import ApiUtils from '../../helper/ApiUtils';
import SubTitleUtils from '../../helper/SubTitleUtils';
import TimeUtils from '../../helper/TimeUtils';

// View
import TranslationsNavbar from '../layout/TranslationsNavbar';
import Spinner from '../common/Spinner';
import WaveformView from '../drogable/WaveformView';
import MultipleFindView from '../multipleFind/MultipleFindView';
import FindPositionAlignView from '../multipleFind/FindPositionAlignView';
import FrameSplitView from '../multipleFind/FrameSplitView';

// Action
import { setTableColWidth } from '../../actions/editTableActions';
import { set_viewWidth } from '../../actions/viewOperationActions';
import { showFindPositionAndAlign } from '../../actions/findActions';
import {
  AddDetialJsonData,
  setTableData,
  copyToSource,
  setIsShowFindAllViewList,
  checkLocalStorageVideoFps,
  setVideoFPS,
  checkLocalPlayerEditingData,
} from '../../actions/transOperationActions';
import {
  setIsShowFindAllViewInput,
  setIsShowFindAllViewReplace,
} from '../../actions/transOperation_find_Actions';
import { showHideMultipleView } from '../../actions/find/mutileFindAction';
import { showHidePositionList } from '../../actions/find/positionFindAction';
import { showHideFrameList } from '../../actions/find/frameFindAction';
import {
  getGetProjectDetial_local,
  jsonData_nolocal,
  setTSubType,
} from '../../actions/subtypeActions';
import DataObj from '../../class/DataObj';

class TranslationsView extends Component {
  constructor(props) {
    super(props);

    this.projectIndex = 0; //專案index
    this.projectData = {}; //專案資料

    this.timecodeIndex = 0; //該字幕Index
    this.timecodeType = 0; //0:開始時間 1:結束時間

    //拖拉工具
    this.videoFps = 0;
    this.frameWidth = 0;
    this.findFrameSplitValue = 0;
    this.fFrameSplit = 0; //檢查frame間格的工具
    this.handleDragValue = 0;
    this.currentDataIndex = 0;
    this.videoCurrentTime = 0;

    //影片
    // this.isPlay = false;

    this.editTableView = React.createRef();
    // this.ITManPlayer = React.createRef();
    //this.DraggableSliderView = React.createRef();
    this.WaveformObjView = React.createRef();
    this.TranslationsNavbar = React.createRef();

    this.state = {
      loading: false,
      loadInitData: false,
      data: null,
      viewWidth: 448, //螢幕寬度
      subtitles_Left: this.props.viewOperation.subtitles_Left, // 字幕編輯寬度
      value: 11,
      errors: {},

      //工具
      videoFps: 0,
      frameWidth: 0,

      /**選單*/
      isShowTranslationsNavbarAlert: false,
      title: 'AppLayout',
      width: 200,
      collapsed: false,
      selectedMenu: null,

      // currentDataIndex:0,
      isEdidMide: 0, //是否為編輯模式,

      /**表格*/
      isShowSource: false,
      frameSpliteErrorArray: [],

      /**影片*/
      VideoUrl: '',
      Project: {},
      projectDetial: {},
      video: {},

      /** 完成提是*/
      isShowComplete: false,
      message: '',

      /** 下載專案內容*/
      loading_jsonData: false,
    };
    this.closefindAllView_input = this.closefindAllView_input.bind(this);
    this.closefindAllView_list = this.closefindAllView_list.bind(this);
    this.closefindAllView_replace = this.closefindAllView_replace.bind(this);
    this.closefindAllView_position = this.closefindAllView_position.bind(this);
    this.closefindAllView_frame = this.closefindAllView_frame.bind(this);
    this.closeTranslationsNavbarAlertView =
      this.closeTranslationsNavbarAlertView.bind(this);

    //layout
    this.handleCollapse = this.handleCollapse.bind(this);
    this.handleExpand = this.handleExpand.bind(this);
    this.handlePanelCollapse = this.handlePanelCollapse.bind(this);

    //拖拉的操作
    this.dragManually = this.dragManually.bind(this); //手拉 結束移動
    this.setHandleDragValue = this.setHandleDragValue.bind(this);
    // this.handleDrag_Manually = this.handleDrag_Manually.bind(this); //手拉 移動中

    //影片動作
    this.onVideoSliderChange = this.onVideoSliderChange.bind(this);
    // this.ITManPlayerActive = this.ITManPlayerActive.bind(this);

    //移動到影片的index

    //Table
    this.updateTimecodeIndex = this.updateTimecodeIndex.bind(this);
    // this.timecode_stopClick = this.timecode_stopClick.bind(this);
    this.playhere = this.playhere.bind(this);
    this.editTablePause = this.editTablePause.bind(this);

    //更新影片時機間
    this.update_videoCurrentTime = this.update_videoCurrentTime.bind(this);
    this.ITManPlayer_play = this.ITManPlayer_play.bind(this);
    this.Jump_Backward_Forward = this.Jump_Backward_Forward.bind(this);

    //選單
    this.toggle = this.toggle.bind(this);
    this.handleItemClick = this.handleItemClick.bind(this);

    this.saveLastData = this.saveLastData.bind(this);
    this.send_deleteSource = this.send_deleteSource.bind(this);

    this.send_Complete = this.send_Complete.bind(this);
  }

  /** 回復上一步驟的紀錄*/
  saveLastData(data, dataIndex) {
    const dataObj = data[dataIndex];

    //修正前 做一個紀錄
    let allBefore = this.props.context.befoCellChangeData;
    allBefore.push({
      rowIndex: dataIndex,
      In: dataObj.In,
      Out: dataObj.Out,
      SubtitleCaption: dataObj.SubtitleCaption,
      Memo: dataObj.Memo,
    });
    this.props.context.setbefoCellChangeData(allBefore);
  }

  /**
   * 快捷鍵
   * */
  onKeyUp(keyName, e, handle) {
    console.log('test:onKeyUp', keyName, e, handle);

   if (keyName === 'ctrl+shift+left') {
      //往左 1 f
      //this.Jump_Backward_Forward('left');
    console.log('往左 1 f test:onKeyDown', keyName, e, handle);
    } 

    // 禁用
    if (keyName === 'ctrl+shift+d') {
      e.preventDefault();
      e.stopPropagation();
    }

    if (keyName === '⌘+down') {
      //開始或結束
      this.ITManPlayer_play();
    } else if (keyName === 'ctrl+down') {
      //開始或結束
      this.ITManPlayer_play();
    } else if (keyName === 'ctrl+right') {
      //開始或結束
      // console.log(`開始或結束`);
      // this.Play_From_Selected_Row()
    } else if (keyName === 'shift+left') {
      //往左５秒
      this.Jump_Backward_Forward('left');
    } else if (keyName === 'shift+right') {
      //往右５秒
      this.Jump_Backward_Forward('right');
    } 
  }
  onKeyDown(keyName, e, handle) {
    console.log('test:onKeyDown', keyName, e, handle);
  }
  ITManPlayer_play() {
    // const isPlayerStartData =  this.props.context.isPlayerStart;
    // if( isPlayerStartData.isPlay === true){
    //     this.ITManPlayerActive(false);
    // }else{
    //     this.ITManPlayerActive(true);
    // }
  }
  Jump_Backward_Forward(direction) {
    //移動
    if (direction === 'left') {
      this.update_videoCurrentTime(this.videoCurrentTime - 5);
    } else {
      this.update_videoCurrentTime(this.videoCurrentTime + 5);
    }

    // this.ITManPlayerActive(true);
  }
  //更新三組物件的當前時間 ：秒數
  update_videoCurrentTime(newCurrentSecond) {
    this.videoCurrentTime = newCurrentSecond;

    // if(this.ITManPlayer.current !== null){
    //     //有影片實體 才更新當前秒數
    //      this.ITManPlayer.dragSetCurrentTime(newCurrentSecond);
    // }

    // this.editTableView.ITManPlayer_currentTime = newCurrentSecond;
  }

  /**
   * Table的操作
   * */
  //表格暫停
  editTablePause() {
    //開播
    // this.ITManPlayerActive(false);
  }
  //按下stop
  // async timecode_stopClick() {
  //
  //     let {data} = this.state;
  //     let dataObj = data[this.timecodeIndex];
  //     let timeString;
  //
  //
  //     //
  //
  //     if (this.timecodeType === 0) {
  //         //In 時間
  //         timeString = dataObj.In;
  //     } else {
  //         //Out 時間
  //         timeString = dataObj.Out;
  //     }
  //
  //     //檢察是不是時間字串
  //     if (StringUtils.checkIsEffectiveTimeString(dataObj.In) === false || StringUtils.checkIsEffectiveTimeString(dataObj.Out) === false) {
  //         return;
  //     }
  //
  //     //更新畫面
  //     let left = TimeUtils.getSubStartPosition(timeString, this.videoFps, this.frameWidth);
  //     this.DraggableSliderView.update_WaveformObjView_handleDragValue(-1 * left); //更新左移
  //
  //     //要更新影片現在的影片時間
  //     let newCurrentSecond = TimeUtils.stringConvertToSeconds(timeString, this.videoFps);
  //     this.update_videoCurrentTime(newCurrentSecond);
  //     this.videoCurrentTime = newCurrentSecond;
  //
  //
  //     //把row帶進去 要從row開始播
  //     this.props.context.updateSubTitle_by_row(this.timecodeIndex);
  //
  // }
  //按下play
  playhere() {
    const { videoFps } = this.props.transOperation;
    const { data } = this.props.editTable;
    let dataObj = data[parseInt(this.timecodeIndex, 10)];
    let timeString = dataObj.In;
    let seconds = TimeUtils.stringConvertToSeconds(timeString, videoFps);
    console.log(`按下 playhere ${seconds}  `);
    this.setAllObjectCurrentDataIndex(this.timecodeIndex);

    //this.ITManPlayer.dragSetCurrentTime(seconds) ;
    //開播
    // this.ITManPlayerActive(true);
  }

  //影片播放或停止
  // ITManPlayerActive(active){
  //     if(active === true){
  //         //影片播放
  //         this.DraggableSliderView.playVideo(true);
  //     }else{
  //         //影片播放
  //         this.DraggableSliderView.playVideo(false);
  //     }
  // }

  setAllObjectCurrentDataIndex(currentDataIndex) {
    this.currentDataIndex = currentDataIndex;
    // this.editTableView.currentDataIndex = currentDataIndex;
    //this.setState({ currentDataIndex: currentDataIndex })
  }

  //更新滑動道的位置
  updateTimecodeIndex(timecodeIndex, timecodeType) {
    this.timecodeIndex = timecodeIndex; //index
    this.timecodeType = timecodeType; //類型
  }

  /**
   * 影片的操作
   * */
  async onVideoSliderChange(newcurrentTime) {
    // TimeUtils.get

    //更新現在的時間
    //const handleDragValue = parseFloat(newcurrentTime)*-1*parseFloat(this.videoFps)*parseFloat(this.frameWidth);
    //改為一秒40px
    const handleDragValue = parseFloat(newcurrentTime) * -1 * 40;

    //更新左移
    this.handleDragValue = handleDragValue; //更新左移

    //控制表格的index
    let newIndex = TimeUtils.secondsConvertToRowIndew(
      newcurrentTime,
      this.videoFps,
      this.state.data
    );
    // console.log(`影片的操作 更新現在的時間　newcurrentTime  ${newcurrentTime} ${handleDragValue} ${newIndex}`);

    // await this.setState({ currentDataIndex: newIndex });
    this.currentDataIndex = parseFloat(newIndex);
    this.setAllObjectCurrentDataIndex(newIndex);

    //讓table移動到正確index位置
    // this.editTableView.moveCellSelect(newIndex);
    this.videoCurrentTime = newcurrentTime;
    //this.editTableView.ITManPlayer_currentTime = newcurrentTime;

    //變更拖拉區的index
    //this.setState({ currentDataIndex: newIndex })
  }

  //posirion位置

  //拖拉
  setHandleDragValue(handleDragValue) {
    //console.log(`頂端 setHandleDragValue`);
    //網上更新
    this.handleDragValue = handleDragValue;
  }

  async dragManually(handleDragValue) {
    //在滑動結束的時候，要更新影片時間
    let newSecond = (handleDragValue * -1) / this.frameWidth / this.videoFps;

    await this.setState({ videoCurrentTime: newSecond });

    //更新影片時間
    this.update_videoCurrentTime(newSecond);

    //控制影片
    //this.ITManPlayer.dragSetCurrentTime(newSecond);
    this.videoCurrentTime = newSecond;

    let dataIndex = TimeUtils.secondsConvertToRowIndew(
      newSecond,
      this.videoFps,
      this.state.data
    );
    this.setAllObjectCurrentDataIndex(dataIndex);

    //更新字幕
    this.props.context.updateSubTitle_by_row(dataIndex);

    //更新播放器時間
    this.props.context.setvideoCurrentTime_byDrag(newSecond);
  }
  /** * end of拖拉的操作　* */
  handleCollapse() {
    this.setState({ collapsed: true });
  }
  handleExpand() {
    this.setState({ collapsed: false });
  }
  handlePanelCollapse() {
    this.setState({ collapsed: true });
  }

  async componentDidMount() {
    await this.setState({ loading: true });

    //確認資料index 跟專案資料
    this.projectIndex = parseInt(this.props.match.params.tIndex, 10);
    const projectListDataString = localStorage.getItem('projectListData');
    //取得本地資料
    this.projectListData = JSON.parse(projectListDataString);

    //findFrameSplitValue 取得frame檢查數值
    this.findFrameSplitValue =
      SubTitleUtils.get_findFrameSplitValue_from_local();
    this.props.context.setfindFrameSplitValue(this.findFrameSplitValue);

    //findFrameSplitValue 取得frame檢查數值
    this.fFrameSplit = SubTitleUtils.get_fFrameSplit_from_local();
    this.props.context.setfFrameSplit(this.fFrameSplit);

    if (this.projectListData !== null) {
      const projectData = this.projectListData[this.projectIndex];
      let { video } = projectData;
      let { FrameRateVal } = video;
      let VideoUrl = video.fURL;

      //取得原本的影片尺寸
      const { WidthVal, HeightVal } = video;
      let newHeight = (458 * HeightVal) / WidthVal;
      await this.props.set_viewWidth(458, newHeight);

      //設定fps
      await this.props.setVideoFPS(FrameRateVal);

      //設定表格的col寬度
      let tableWidth =
        window.innerWidth - this.props.viewOperation.subtitles_Left - 100;
      await this.props.setTableColWidth(tableWidth, 0, this.props.editTable);

      await this.setState({ projectData: projectData });

      //影片url
      await this.setState({ VideoUrl: VideoUrl });

      //projectDetial
      await this.setState({ Project: projectData.Project });
      await this.setState({ projectDetial: projectData.projectDetial });
      await this.setState({ video: projectData.video });

      await this.props.setTSubType(projectData.Project.tSubType);

      this.props.setTSubType(projectData.Project.tSubType);
      WaveformView.projectSubType = projectData.Project.tSubType;
      DataObj.projectSubType = projectData.Project.tSubType;

      /**
       * 取專案資料
       * */
      const { user } = this.props.auth;
      const email = user['email'];
      await this.setState({ loading_jsonData: true });
      const __PlayerEditingData = await this.props.jsonData_nolocal(
        parseFloat(FrameRateVal),
        projectData.projectDetial.fId,
        email
      );
      await this.setState({ loading_jsonData: false });
      // const jsonData = ApiUtils.get_sql(`${ApiUtils.get_DetialJsonData}?tProjectDetialId=${projectData.projectDetial.fId}`);
      // console.log(`jsonData ${`${ApiUtils.get_DetialJsonData}?tProjectDetialId=${projectData.projectDetial.fId}`} ${JSON.stringify(jsonData)}`);

      //上網拉資料進來

      //透過projectIndex 來取得這個專案的資料
      /**
       * 先確認有無本地資料
       * */
      const { videoFps, frameWidth } = this.props.transOperation;
      await this.setState({ videoFps, frameWidth });

      this.frameWidth = frameWidth;
      this.videoFps = videoFps;

      //設定全域變數
      window.videoFps = this.videoFps;

      this.props.context.setvideoFps(videoFps);
      this.props.context.setframeWidth(frameWidth);

      //確認有無儲存本地資訊
      //初始字幕跟拖拉資料
      this.props.context.initSubAndDragData();

      //建立字幕列表 現在已經不使用 PlayerEditingData

      await this.props.checkLocalPlayerEditingData(
        __PlayerEditingData, // 傳入字幕列表.
        this.findFrameSplitValue,
        this.state.videoFps
      );

      // if(isGetLocalData === true){
      //     //取得本地projectListData
      //     await this.props.getGetProjectDetial_local();

      //     const{data} = this.props.editTable;

      //     if(data !== null){
      //         await this.setState({ data:data });
      //     }
      //     await this.setState({ value: this.props.project.statusValue });
      // }

      //取得本地projectListData
      await this.props.getGetProjectDetial_local(this.projectListData);
      const { data } = this.props.editTable;

      if (data !== null) {
        await this.setState({ data: data });
      }

      await this.setState({ value: this.props.project.statusValue });

      //確認本地FPS
      await this.props.checkLocalStorageVideoFps(this.videoFps);
    }

    await this.setState({ loading: false });
  }

  async closefindAllView_input() {
    this.props.setIsShowFindAllViewInput(false);
  }
  async closefindAllView_list() {
    this.props.setIsShowFindAllViewList(false);
  }
  async closefindAllView_replace() {
    this.props.setIsShowFindAllViewReplace(false);
  }
  async closefindAllView_position() {
    this.props.showHidePositionList(false);
  }
  async closefindAllView_frame() {
    this.props.showHideFrameList(false);
  }

  /**
   * 選單
   * */
  async toggle() {
    const { collapsed, isShowTranslationsNavbarAlert } = this.state;
    // await this.setState({
    //     collapsed: !collapsed,
    //     isShowTranslationsNavbarAlert:!isShowTranslationsNavbarAlert
    // });
    await this.setState({
      isShowTranslationsNavbarAlert: !isShowTranslationsNavbarAlert,
    });
  }
  handleItemClick(item) {
    this.setState({ selectedMenu: item });
  }

  closeTranslationsNavbarAlertView() {
    this.setState({ isShowTranslationsNavbarAlert: false });
  }

  async componentWillReceiveProps(nextProps) {
    if (
      nextProps.findOperation.isPositionAlignDialog !==
      this.state.isPositionAlignDialog
    ) {
      this.setState({
        isPositionAlignDialog: nextProps.findOperation.isPositionAlignDialog,
      });
    }
  }

  //發送成功訊息
  async send_Complete() {
    const { projectDetial } = this.state;

    //檢查有沒有下一步
    const nextStepResult = await ApiUtils.get_sql(
      `${ApiUtils.post_CheckIsHaveNext}?tProjectDetialId=${projectDetial.fId}`
    );

    //直行完成下一步驟
    await ApiUtils.get_sql(
      `${ApiUtils.get_CompleteStep}?tProjectDetialId=${projectDetial.fId}`
    );

    // alert('Send Complete message');

    // return ;

    this.props.history.push('/Home');

    window.location.reload();
  }

  async send_deleteSource() {
    await this.props.deleteSource(this.props.editTable.data);

    const { user } = this.props.auth;
    const email = user['email'];

    //儲存
    await this.props.AddDetialJsonData({
      tProjectDetialId: this.props.projectDetial.fId,
      jsonstring: this.props.editTable.data,
      email: email,
    });
  }

  render() {
    //工具
    const {
      loading,
      videoFps,
      frameWidth,
      projectData,
      projectDetial,
      video,
      isShowComplete,
      message,
    } = this.state;

    //選單
    const {
      data,
      width,
      selectedMenu,
      collapsed,
      isShowTranslationsNavbarAlert,
    } = this.state;
    const { videoDuration } = this.props.videoPlayer;
    const { isShowMutileFindDialog, isShowFrameSplitError } =
      this.props.findOperation;
    const { isPositionAlignDialog } = this.state;
    //影片視窗寬度

    let mainContent;

    if (data === null) {
      mainContent = <div className='pt-5'>__</div>;
    } else if (loading === true) {
      mainContent = (
        <div className='pt-5'>
          <Spinner />
        </div>
      );
    } else {
      // 時間計算總類
      let { Project } = projectData;
      let { tSubType } = Project;

      mainContent = (
        <div
          className='w-100'
          style={{ overflow_x: 'hidden', backgroundColor: '#dfdde0' }}
        >
          <SubtitleContext.Consumer>
            {(context) => (
              <WaveformView
                onRef={(ref) => (this.WaveformObjView = ref)}
                context={context}
                setHandleDragValue={this.setHandleDragValue}
                data={data}
                tSubType={tSubType}
                currentDataIndex={this.currentDataIndex}
                videoCurrentTime={this.videoCurrentTime}
                videoDuration={videoDuration}
                videoFps={videoFps}
                frameWidth={frameWidth}
                findFrameSplitValue={this.findFrameSplitValue}
                projectDetial={projectDetial}
                video={video} //影片資料
                //function
                // handleDragValue={handleDragValue}
                setDoubleClick={(newIndex) => {
                  this.WaveformObjView.setDoubleClick(newIndex);
                }}
                dragManually={this.props.dragManually}
              />
            )}
          </SubtitleContext.Consumer>
        </div>
      );
    }

    return (
      <SubtitleContext.Consumer>
        {(context) => (
          <div
            id='TranslationsView'
            className='m-0 p-0'
            style={{
              backgroundColor: '#dfdde0',
              // marginLeft:'20px',
              // marginRight:'20px'
            }}
          >
            <div className='f-column ' style={{ backgroundColor: '#dfdde0' }}>
              <div className='f-row f-full '>
                <div className='main-body f-full '>
                  {selectedMenu && <p>{selectedMenu.text}</p>}
                  {mainContent}

                  {/*載入資料中*/}
                  {this.state.loading_jsonData === true ? (
                    <div>
                      <Segment>
                        <Dimmer active inverted>
                          <Loader inverted>Loading</Loader>
                        </Dimmer>

                        <Image src='https://react.semantic-ui.com/images/wireframe/short-paragraph.png' />
                      </Segment>
                    </div>
                  ) : null}
                </div>
                　
              </div>

              <div
                className='sidebar-body f-animate'
                style={{
                  backgroundColor: 'white',
                  zIndex: '5',
                  position: 'absolute',
                  top: '40px',
                  right: '0px',
                  width: width,
                }}
              >
                {/*導覽*/}
                <Popup
                  open={isShowTranslationsNavbarAlert}
                  modal
                  closeOnDocumentClick
                  onClose={this.closeTranslationsNavbarAlertView}
                  contentStyle={{
                    width: '200px',
                    position: 'absolute',
                    right: '10px',
                    top: '50px',
                  }}
                >
                  <SubtitleContext.Consumer>
                    {(context) => (
                      <TranslationsNavbar
                        ref={(ref) => (this.TranslationsNavbar = ref)}
                        context={context}
                        closeTranslationsNavbarAlertView={
                          this.closeTranslationsNavbarAlertView
                        }
                        data={data}
                        collapsed={collapsed}
                        findFrameSplitValue={this.findFrameSplitValue}
                        videoFps={videoFps}
                        projectData={projectData}
                        projectDetial={projectDetial}
                        updateEditTableData={(newData) => {
                          this.WaveformObjView.updateEditTableData(newData);
                        }}
                        onRef={(ref) => (this.TranslationsNavbar = ref)}
                        setDoubleClick={(newIndex) => {
                          //往下呼叫
                          this.WaveformObjView.setDoubleClick(newIndex);
                        }}
                        //檢查錯誤
                        WaveformObjView_checkFrameSplitErrorArray={() => {
                          this.WaveformObjView.checkFrameSplitErrorArray();
                        }}
                        promptGoToLine={() => {}}
                        sendComplete={async (FindFrameTargetData) => {
                          //開始搜尋

                          // const FindFrameTargetData = this.WaveformObjView.sendComplete();

                          let message = '';

                          if (FindFrameTargetData.length !== 0) {
                            message = 'Need check Frame Split';
                          }

                          await this.setState({ message: message });

                          await this.setState({ isShowComplete: true });
                        }}
                        senddeleteSource={() => {
                          confirmAlert({
                            title: 'WARNING',
                            message: 'Delete Source',
                            buttons: [
                              {
                                label: 'Ok',
                                onClick: () => this.send_deleteSource(),
                              },
                              {
                                label: 'Cancel',
                              },
                            ],
                          });

                          this.closeTranslationsNavbarAlertView();
                        }}
                        sendCopyToSource={() => {
                          confirmAlert({
                            title: 'WARNING',
                            message:
                              'The texts in Target column will be copied to Source column.\n' +
                              'This action is NOT reversible',
                            buttons: [
                              {
                                label: 'Proceed',
                                onClick: async () => {
                                  await this.props.copyToSource(
                                    this.props.editTable.data,
                                    this.findFrameSplitValue,
                                    this.videoFps
                                  );

                                  const { user } = this.props.auth;
                                  const email = user['email'];

                                  //儲存
                                  await this.props.AddDetialJsonData({
                                    tProjectDetialId: projectDetial.fId,
                                    jsonstring: this.props.editTable.data,
                                    email: email,
                                  });
                                },
                              },
                              {
                                label: 'Cancel',
                              },
                            ],
                          });
                          this.closeTranslationsNavbarAlertView();
                        }}
                      />
                    )}
                  </SubtitleContext.Consumer>
                </Popup>
              </div>

              <Popup
                open={isShowComplete}
                modal
                closeOnDocumentClick
                onClose={() => {
                  this.setState({ isShowComplete: false });
                }}
                contentStyle={{}}
              >
                <div className='custom-ui' style={{ height: '500px' }}>
                  <h3>Send Complete message</h3>
                  <div>
                    <label>{message}</label>
                  </div>
                  <Button
                    type='button'
                    color='blue'
                    onClick={async () => {
                      await this.setState({ loading: true });

                      await this.send_Complete();

                      await this.setState({ loading: false });

                      await this.setState({ isShowComplete: false });
                    }}
                  >
                    Submit
                  </Button>
                  <Button
                    type='button'
                    basic={true}
                    onClick={async () => {
                      await this.setState({ isShowComplete: false });
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Popup>

              {isShowMutileFindDialog && <MultipleFindView />}

              <Popup
                open={isPositionAlignDialog}
                modal
                closeOnDocumentClick
                onClose={() => {
                  this.props.showFindPositionAndAlign(false);
                }}
                contentStyle={{ width: '450px' }}
              >
                <FindPositionAlignView />
              </Popup>

              <Popup
                open={isShowFrameSplitError}
                modal
                closeOnDocumentClick
                onClose={() => {
                  this.setState({ isShowFrameSplitError: false });
                }}
                contentStyle={{ width: '450px' }}
              >
                <SubtitleContext.Consumer>
                  {(context) => <FrameSplitView context={context} />}
                </SubtitleContext.Consumer>
              </Popup>
            </div>
          </div>
        )}
      </SubtitleContext.Consumer>
    );
  }
}

TranslationsView.propTypes = {
  errors: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired, 
  findOperation: PropTypes.object.isRequired,
  viewOperation: PropTypes.object.isRequired,
  videoPlayer: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
  errors: state.errors,
  transOperation: state.transOperation,
  findOperation: state.findOperation,
  viewOperation: state.viewOperation,
  editTable: state.editTable,
  frameControl: state.frameControl,
  videoPlayer: state.videoPlayer,
  userOperation: state.userOperation,
});

export default connect(mapStateToProps, {
  // goToLine,
  setTSubType,
  setTableData,
  setIsShowFindAllViewInput,
  setIsShowFindAllViewList,
  setIsShowFindAllViewReplace,
  showHideMultipleView,
  showHidePositionList,
  showFindPositionAndAlign,
  showHideFrameList,
  checkLocalStorageVideoFps,
  getGetProjectDetial_local,
  checkLocalPlayerEditingData,
  copyToSource,
  jsonData_nolocal,
  setVideoFPS,
  set_viewWidth,
  setTableColWidth,
  AddDetialJsonData,
})(withRouter(TranslationsView));



// WEBPACK FOOTER //
// ./src/components/translations/TranslationsView.js